import { useMemo } from 'react'

const isAsyncFn = (fn) => fn.constructor.name === 'AsyncFunction'

// Returns a memoized and debounced version of the given function.
export const useDebounce = (fn, delay) =>
  useMemo(() => {
    let timeoutId

    return (...args) => {
      if (timeoutId) {
        clearTimeout(timeoutId)
      }

      return new Promise((resolve, reject) => {
        timeoutId = setTimeout(() => {
          if (isAsyncFn(fn)) {
            fn(...args)
              .then(resolve)
              .catch(reject)
          } else {
            resolve(fn(...args))
          }
        }, delay)
      })
    }
  }, [fn, delay])
